/** 鼠标点击类型 */
export enum MouseButtonType {
    LEFT = 0,
    MIDDLE = 1,
    RIGHT = 2,
}

export const isLeftButton = function (
    ev: React.MouseEvent<HTMLDivElement | Element | HTMLElement, MouseEvent> | MouseEvent,
) {
    return ev.button === MouseButtonType.LEFT;
};
